import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import WorkBenchView from '@/views/WorkBenchView.vue'
import DemoView from '@/views/DemoView.vue'
import HomeView from '@/views/HomeView.vue'
import AboutView from '@/views/AboutView.vue'
import GetInvolvedView from '@/views/GetInvolvedView.vue'
import SupportView from '@/views/SupportView.vue'
import ContactView from '@/views/ContactView.vue'
import DonateView from '@/views/DonateView.vue'
import WhyLinuxView from '@/views/WhyLinuxView.vue'
import RequestFormView from '@/views/RequestFormView.vue'
import VolunteerSignupView from '@/views/VolunteerSignupView.vue'
import ThePlanView from '@/views/ThePlanView.vue'
import FlyersView from '@/views/FlyersView.vue'
import FlyerThePlanView from '@/views/FlyerThePlanView.vue'
import FlyerITView from '@/views/FlyerITView.vue'
import FlyerDropBoxView from '@/views/FlyerDropBoxView.vue'
import FlyerGeneralInfoView from '@/views/FlyerGeneralInfoView.vue'
import StudentsView from '@/views/StudentsView.vue'
import CoursesView from '@/views/CoursesView.vue'
import MattermostView from '@/views/MattermostView.vue'
import MattermostRequestView from '@/views/MattermostRequestView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView
  },
  {
    path: '/get-involved',
    name: 'GetInvolved',
    component: GetInvolvedView
  },
  {
    path: '/support',
    name: 'Support',
    component: SupportView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/donate',
    name: 'Donate',
    component: DonateView
  },
  {
    path: '/why-linux',
    name: 'WhyLinux',
    component: WhyLinuxView
  },
  {
    path: '/demo',
    name: 'Demo',
    component: DemoView
  },
  {
    path: '/request',
    name: 'RequestEquipment',
    component: RequestFormView
  },
  {
    path: '/volunteer',
    name: 'VolunteerSignup',
    component: VolunteerSignupView
  },
  {
    path: '/theplan',
    name: 'ThePlan',
    component: ThePlanView
  },
  {
    path: '/students',
    name: 'Students',
    component: StudentsView
  },
  {
    path: '/students/courses',
    name: 'StudentCourses',
    component: CoursesView
  },
  {
    path: '/students/mattermost',
    name: 'StudentMattermost',
    component: MattermostView
  },
  {
    path: '/students/mattermost/request',
    name: 'StudentMattermostRequest',
    component: MattermostRequestView
  },
  {
    path: '/flyers',
    name: 'Flyers',
    component: FlyersView
  },
  {
    path: '/flyers/theplan',
    name: 'FlyerThePlan',
    component: FlyerThePlanView
  },
  {
    path: '/flyers/it',
    name: 'FlyerIT',
    component: FlyerITView
  },
  {
    path: '/flyers/dropbox',
    name: 'FlyerDropBox',
    component: FlyerDropBoxView
  },
  {
    path: '/flyers/general',
    name: 'FlyerGeneralInfo',
    component: FlyerGeneralInfoView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (browser back/forward), use it
    if (savedPosition) {
      return savedPosition
    }
    // If there's a hash (anchor link), scroll to that element
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    // Otherwise, scroll to the top
    return { top: 0, behavior: 'smooth' }
  }
})

export default router
